
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch, useSelector } from 'react-redux';

import ToolButton from '../toolbar/ToolButton';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandZoomDefault = (props) => {

    const dispatch = useDispatch();
    const mapDefinition = useSelector(state => state.map.definition);

    const getDefaultExtent = () => {
        return props.defaultExtent || mapDefinition.defaultExtent || mapDefinition.extent;
    }

    const getDefaultCenterZooom = () => {
        return (mapDefinition.defaultCenter && mapDefinition.defaultZoom)
            ? {
                center: mapDefinition.defaultCenter,
                zoom: mapDefinition.defaultZoom
            }
            : {
                center: mapDefinition.center,
                zoom: mapDefinition.zoom
            };
    }

    const onClick = () => {
        const extent = getDefaultExtent();

        if (extent) {
            buttonCommandClick(
                dispatch,
                'ZOOM_FEATURE',
                {
                    wkt: `LINESTRING (${extent[0]} ${extent[1]},${extent[2]} ${extent[3]})`,
                }
            );
        } else {
            const centerZoom = getDefaultCenterZooom();
            buttonCommandClick(
                dispatch,
                'SET_CENTER',
                {
                    x: centerZoom.center[0],
                    y: centerZoom.center[1],
                    zoom: centerZoom.zoom
                }
            );
        }
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('FitPage')}
            title="Výchozí výřez"
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomDefault;
